import React, {useEffect, useLayoutEffect, useRef} from 'react';
import {Navigate, Route, Routes, useLocation, useNavigate} from 'react-router-dom';
import NotFoundScreen from "../screens/not-found/notFoundScreen";
import TestScreen from "../screens/test/TestScreen";
import DesignSystemScreen from "../screens/design-system/DesignSystemScreen";
import ComingSoonScreen from "../screens/coming-soon/ComingSoonScreen";

import {
    APPOINTMENT_DETAILS_ROUTE,
    APPOINTMENTS_LIST_ROUTE,
    CASE_DETAILS,
    CASES,
    CLIENT_INJURY_DETAILS_ROUTE,
    CLIENT_INJURY_SUCCESS_ROUTE,
    CLIENT_REGISTRATION_CONSENT_ROUTE,
    CLIENT_REGISTRATION_ROUTE,
    COMING_SOON_ROUTE,
    DESIGN_SYSTEM_ROUTE,
    LOGIN_ROUTE,
    NOT_FOUND_ROUTE,
    ON_BOARDING_ROUTE,
    PROFILE_DETAILS_ROUTE,
    PROFILE_EDIT_ROUTE,
    PROFILE_LINKING_ROUTE,
    PROFILE_ROUTE,
    TEST_ROUTE,
    APPOINTMENTS_AUTHORIZATION_TO_RELEASE_MEDICAL_INFORMATION,
    APPOINTMENTS_AUTHORIZATION_TO_RELEASE_MEDICAL_INFORMATION_DETAILS,
    APPOINTMENTS_CERTIFICATION_AND_CONSENT_DETAILS,
    APPOINTMENTS_INJURY_DETAILS,
    APPOINTMENTS_INJURY_DETAILS_ADD,
    APPOINTMENTS_CERTIFICATION_AND_CONSENT_ADD,
    ACTIVITY_LOGS,
    MEDICAL_HISTORY_QUESTIONNAIRE_ROUTE,
    PREFERENCE_ROUTE,
    BOOK_APPOINTMENTS_ROUTE,
    OTHER_SHARED_DOCUMENTS_ROUTE,
    CASES_RECORD_DETAILS_ROUTE,
    PERFORMANCE_RECORD_DETAILS_ROUTE,
    TRANSACTIONS_ROUTE,
    TRANSACTION_DETAILS_ROUTE,
    DASHBOARD_ROUTE,
    CLIENT_RESOURCE_ROUTE,
    WAIVER_AND_RELEASE_ROUTE,
    DISCLOSE_AND_RELEASE_ROUTE,
    EDIT_HEALTH_AND_RELEASE_ROUTE,
    ADD_HEALTH_AND_RELEASE_ROUTE,
    ADD_WAIVER_AND_RELEASE_ROUTE
} from "../constants/RoutesConfig";
import ClientInjuryDetailsScreen from "../screens/client-registration/client-injury-details/ClientInjuryDetailsScreen";
import ClientSuccessScreen from "../screens/client-success/ClientSuccessScreen";
import AppLayout from "../layouts/app-layout/AppLayout";
import LoginScreen from "../screens/account/login/LoginScreen";
import OnboardingScreen from "../screens/account/onboarding/OnboardingScreen";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../store/reducers";
import ClientRegistrationScreen from "../screens/client-registration/ClientRegistrationScreen";
import ClientRegistrationConsentScreen from "../screens/client-registration-consent/ClientRegistrationConsentScreen";
import RegistrationLayout from "../layouts/registeration-layout/RegistrationLayout";
import AppointmentsScreen from "../screens/appointments/AppointmentsScreen";
import ClientCasesListScreen from "../screens/client-cases/client-cases-list/ClientCasesListScreen";
import AppointmentDetailsScreen from "../screens/appointments/appointment-details/AppointmentDetailsScreen";
import ProfileDetailsLayoutComponent from "../screens/profile/profile-details-layout/ProfileDetailsLayoutComponent";
import ProfileViewDetailsLayoutComponent
    from "../screens/profile/my-profile/profile-view-details-layout/ProfileViewDetailsLayoutComponent";
import ClientEditScreen from "../screens/profile/my-profile/client-edit/ClientEditScreen";
import ProfileLinkingLayoutComponent
    from "../screens/profile/profile-linking/profile-linking-layout/ProfileLinkingLayoutComponent";
import AuthLayout from "../layouts/auth-layout/AuthLayout";
import AppointmentsInjuryDetailsFormViewEditComponent
    from "../screens/appointments/appointment-details/appointments-injury-details-form-view-edit/AppointmentsInjuryDetailsFormViewEditComponent";
import AppointmentsCertificationAndConsentFormViewEditComponent
    from "../screens/appointments/appointment-details/appointments-certification-and-consent-form-view-edit/AppointmentsCertificationAndConsentFormViewEditComponent";
import AppointmentsAuthorizationToMedicalInformationFormViewEditComponent
    from "../screens/appointments/appointment-details/appointments-authorization-to-medical-information-form-view-edit/AppointmentsAuthorizationToMedicalInformationFormViewEditComponent";
import AppointmentsCertificationAndConsentAddComponent
    from "../screens/appointments/appointment-details/appointments-certification-and-consent-add/AppointmentsCertificationAndConsentAddComponent";
import AppointmentsAutharizationReleaseInformationAddComponent
    from "../screens/appointments/appointment-details/appointments-autharization-release-information-add/AppointmentsAutharizationReleaseInformationAddComponent";
import AppointmentsInjuryDetailsFormAddComponent
    from "../screens/appointments/appointment-details/appointments-injury-details-form-add/AppointmentsInjuryDetailsFormAddComponent";
import NoInternetComponent from "../shared/components/no-internet/NoInternetComponent";
import ClientActivityLogComponent from "../screens/client-activity-log/ClientActivityLogComponent";
import ClientMedicalDetailsComponent
    from "../screens/profile/my-profile/client-medical-details/ClientMedicalDetailsComponent";
import ClientAccountDetailsComponent
    from "../screens/profile/my-profile/client-account-details/ClientAccountDetailsComponent";
import BookAppointmentComponent from "../screens/book-appointment/BookAppointmentComponent";
import OtherSharedDocumentList from "../screens/client-cases/other-shared-documents/OtherSharedDocumentList";
import RecordDetailsLayoutScreen from "../screens/client-cases/record-details-layout/RecordDetailsLayoutScreen";
import PerformanceDetailsLayoutScreen
    from "../screens/client-cases/performace-record-details-layout/PerformanceDetailsLayoutScreen";
import TransactionLayoutScreen from "../screens/transaction/transaction-layout/TransactionLayoutScreen";
import TransactionDetailsScreen from "../screens/transaction/transaction-details/TransactionDetailsScreen";
import DashboardScreen from "../screens/dashboard/dashboard-screen/DashboardScreen";
import ClientResourcesScreen from "../screens/dashboard/client-resources/ClientResourcesScreen";
import WaiverAndReleaseFormScreen from "../screens/dashboard/waiver-and-release/WaiverAndReleaseFormScreen";
import ClientAuthorisationToDiscloseInfoFormScreen
    from "../screens/dashboard/client-authorisation-to-disclose-info/ClientAuthorisationToDiscloseInfoFormScreen";
import ClientAuthorisationToReleaseHealthInfo
    from "../screens/dashboard/client-authorisation-to-release-health-info/ClientAuthorisationToReleaseHealthInfo";
import {CommonService} from "../shared/services";

const ProtectedRoute = (props: React.PropsWithChildren<any>) => {

    const {children} = props;
    const {token, currentUser} = useSelector((state: IRootReducerState) => state.account);
    const navigate = useNavigate();
    const location = useLocation();

    const hasRedirected = useRef(false);

    useEffect(() => {
        if (!token) {
            navigate('/login?returnUrl=' + encodeURIComponent(location.pathname + location.search));
            return; // Stop further execution
        }

        if (!hasRedirected.current && currentUser?.is_profile_completed === false) {
            hasRedirected.current = true;
            navigate(CommonService._routeConfig.ClientOnboarding());
        }
    }, [token, navigate, location, currentUser]);

    return (
        <NoInternetComponent>
            {children}
        </NoInternetComponent>
    );
}
//
// const UnProtectedRoute = (props: React.PropsWithChildren<any>) => {
//
//     const {children} = props;
//     const {token} = useSelector((state: IRootReducerState) => state.account);
//     const navigate = useNavigate();
//     const location = useLocation();
//
//     useEffect(() => {
//         let returnUrl = CommonService._routeConfig.DefaultRoute();
//         const query = CommonService.parseQueryString(location.search);
//         if (Object.keys(query).includes('returnUrl')) {
//             returnUrl = query.returnUrl;
//         }
//         if (!!token) {
//             navigate(returnUrl);
//         }
//     }, [token, navigate, location]);
//
//     return children;
// }

export interface NavigatorProps {

}

const Navigator = (props: NavigatorProps) => {

    const location = useLocation();

    useLayoutEffect(() => {
        document.querySelector("body")?.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <NoInternetComponent>
            <Routes>
                <Route element={<AppLayout/>}>
                    <Route index
                           element={
                               <ProtectedRoute>
                                   <DashboardScreen/>
                               </ProtectedRoute>
                           }
                    />
                    <Route path={DASHBOARD_ROUTE} element={<ProtectedRoute>
                        <DashboardScreen/>
                    </ProtectedRoute>}/>
                    <Route path={CLIENT_RESOURCE_ROUTE} element={<ProtectedRoute>
                        <ClientResourcesScreen/>
                    </ProtectedRoute>}/>
                    <Route path={WAIVER_AND_RELEASE_ROUTE} element={<ProtectedRoute>
                        <WaiverAndReleaseFormScreen/>
                    </ProtectedRoute>}/>
                    <Route path={ADD_WAIVER_AND_RELEASE_ROUTE} element={<ProtectedRoute>
                        <WaiverAndReleaseFormScreen/>
                    </ProtectedRoute>}/>
                    <Route path={DISCLOSE_AND_RELEASE_ROUTE} element={<ProtectedRoute>
                        <ClientAuthorisationToDiscloseInfoFormScreen/>
                    </ProtectedRoute>}/>
                    <Route path={EDIT_HEALTH_AND_RELEASE_ROUTE} element={<ProtectedRoute>
                        <ClientAuthorisationToReleaseHealthInfo/>
                    </ProtectedRoute>}/>
                    <Route path={ADD_HEALTH_AND_RELEASE_ROUTE} element={<ProtectedRoute>
                        <ClientAuthorisationToReleaseHealthInfo/>
                    </ProtectedRoute>}/>
                    <Route path={APPOINTMENTS_LIST_ROUTE} element={<ProtectedRoute>
                        <AppointmentsScreen/>
                    </ProtectedRoute>}/>
                    <Route path={CASES} element={<ProtectedRoute>
                        <ClientCasesListScreen/>
                    </ProtectedRoute>}/>
                    <Route path={CASE_DETAILS} element={<ProtectedRoute>
                        <RecordDetailsLayoutScreen/>
                    </ProtectedRoute>}/>
                    <Route path={PERFORMANCE_RECORD_DETAILS_ROUTE} element={<ProtectedRoute>
                        <PerformanceDetailsLayoutScreen/>
                    </ProtectedRoute>}/>
                    <Route path={OTHER_SHARED_DOCUMENTS_ROUTE} element={<ProtectedRoute>
                        <OtherSharedDocumentList/>
                    </ProtectedRoute>}/>
                    <Route path={CASES_RECORD_DETAILS_ROUTE} element={<ProtectedRoute>
                        <RecordDetailsLayoutScreen/>
                    </ProtectedRoute>}/>
                    <Route path={TRANSACTIONS_ROUTE} element={<ProtectedRoute>
                        <TransactionLayoutScreen/>
                    </ProtectedRoute>}/>
                    <Route path={TRANSACTION_DETAILS_ROUTE} element={<ProtectedRoute>
                        <TransactionDetailsScreen/>
                    </ProtectedRoute>}/>
                    <Route path={APPOINTMENT_DETAILS_ROUTE} element={<ProtectedRoute>
                        <AppointmentDetailsScreen/>
                    </ProtectedRoute>}/>
                    <Route path={BOOK_APPOINTMENTS_ROUTE} element={<ProtectedRoute>
                        <BookAppointmentComponent/>
                    </ProtectedRoute>}/>
                    <Route path={PROFILE_ROUTE} element={<ProfileDetailsLayoutComponent/>} {...props}>
                        <Route
                            index
                            element={
                                <Navigate to={PROFILE_DETAILS_ROUTE}/>
                            }
                        />
                        <Route
                            path={PROFILE_DETAILS_ROUTE}
                            element={
                                <ProtectedRoute>
                                    <ProfileViewDetailsLayoutComponent/>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={MEDICAL_HISTORY_QUESTIONNAIRE_ROUTE}
                            element={
                                <ProtectedRoute>
                                    <ClientMedicalDetailsComponent/>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={PREFERENCE_ROUTE}
                            element={
                                <ProtectedRoute>
                                    <ClientAccountDetailsComponent/>
                                </ProtectedRoute>
                            }
                        />
                        <Route path={PROFILE_LINKING_ROUTE} element={
                            <ProtectedRoute>
                                <ProfileLinkingLayoutComponent/>
                            </ProtectedRoute>
                        }/>
                    </Route>

                    <Route path={PROFILE_EDIT_ROUTE} element={<ProtectedRoute>
                        <ClientEditScreen/>
                    </ProtectedRoute>}/>

                    <Route path={APPOINTMENT_DETAILS_ROUTE} element={<ProtectedRoute>
                        <AppointmentDetailsScreen/>
                    </ProtectedRoute>}/>
                    <Route path={APPOINTMENTS_INJURY_DETAILS} element={<ProtectedRoute>
                        <AppointmentsInjuryDetailsFormViewEditComponent/>
                    </ProtectedRoute>}/>
                    <Route path={APPOINTMENTS_INJURY_DETAILS_ADD} element={<ProtectedRoute>
                        <AppointmentsInjuryDetailsFormAddComponent/>
                    </ProtectedRoute>}/>
                    <Route path={APPOINTMENTS_CERTIFICATION_AND_CONSENT_ADD} element={<ProtectedRoute>
                        <AppointmentsCertificationAndConsentAddComponent/>
                    </ProtectedRoute>}/>
                    <Route path={APPOINTMENTS_AUTHORIZATION_TO_RELEASE_MEDICAL_INFORMATION} element={<ProtectedRoute>
                        <AppointmentsAutharizationReleaseInformationAddComponent/>
                    </ProtectedRoute>}/>
                    <Route path={APPOINTMENTS_AUTHORIZATION_TO_RELEASE_MEDICAL_INFORMATION_DETAILS}
                           element={<ProtectedRoute>
                               <AppointmentsCertificationAndConsentFormViewEditComponent/>
                           </ProtectedRoute>}/>
                    <Route path={APPOINTMENTS_CERTIFICATION_AND_CONSENT_DETAILS} element={<ProtectedRoute>
                        <AppointmentsAuthorizationToMedicalInformationFormViewEditComponent/>
                    </ProtectedRoute>}/>
                    <Route path={ACTIVITY_LOGS}
                           element={<ProtectedRoute>
                               <ClientActivityLogComponent/>
                           </ProtectedRoute>}/>

                    <Route path={TEST_ROUTE} element={<TestScreen/>}/>
                    <Route path={COMING_SOON_ROUTE} element={<ComingSoonScreen/>}/>
                </Route>
                <Route element={<RegistrationLayout/>}>
                    <Route path={CLIENT_INJURY_DETAILS_ROUTE} element={
                        <ProtectedRoute>
                            <ClientInjuryDetailsScreen appointmentId={""}/>
                        </ProtectedRoute>}/>
                    <Route path={CLIENT_INJURY_SUCCESS_ROUTE} element={
                        <ProtectedRoute>
                            <ClientSuccessScreen/>
                        </ProtectedRoute>}/>
                    <Route
                        path={ON_BOARDING_ROUTE}
                        element={
                            <ProtectedRoute>
                                <OnboardingScreen/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={CLIENT_REGISTRATION_ROUTE}
                        element={
                            <ProtectedRoute>
                                <ClientRegistrationScreen/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={CLIENT_REGISTRATION_CONSENT_ROUTE}
                        element={
                            <ProtectedRoute>
                                <ClientRegistrationConsentScreen/>
                            </ProtectedRoute>
                        }
                    />
                </Route>
                <Route element={<AuthLayout/>}>
                    <Route index element={
                        <LoginScreen/>
                    }/>
                    <Route path={LOGIN_ROUTE} element={
                        <LoginScreen/>
                    }/>
                </Route>
                <Route path={DESIGN_SYSTEM_ROUTE} element={<DesignSystemScreen/>}/>
                <Route path={COMING_SOON_ROUTE} element={<ComingSoonScreen/>}/>
                <Route path={TEST_ROUTE} element={<TestScreen/>}/>
                <Route path={DESIGN_SYSTEM_ROUTE} element={<DesignSystemScreen/>}/>
                <Route path={NOT_FOUND_ROUTE} element={<NotFoundScreen/>}/>
                <Route path="*" element={<Navigate to={NOT_FOUND_ROUTE}/>}/>
            </Routes>
        </NoInternetComponent>
    )
};

export default Navigator;
